export default "__VITE_ASSET__DyYUNpes__"